import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HorseList from './HorseList';
import { useTranslate } from './TranslationText';
import { Link } from 'react-router-dom';

export default function ClassAccordion({ showData, isChampion = false, isFireStore = false, expandedClass, index, handleChangeClass, item, expanded, handleChange, islive, currentHorseData, handleHorseimages, selectedHorseId, horsesRef }) {
    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const isEn = currentLanguage == 'en';
    const showClassHorseList = isChampion == true ? item?.horses?.map((h) => ({
        id: h?.horseChampoinID,
        horseNumber: h?.horseNumber,
        horseName: h?.horseName,
        rank: h?.rank,
        totalPoint: h?.totalPoints,
        reason: h?.reason,
        sire: h?.sire,
        dam: h?.dam,
        breeder: h?.breeder,
        owner: h?.owner,
        color: h?.color,
        birthDate: h?.birthDate,
        classHorseScoringModel: {
            scoringTable: [],
            classHorseGallery: []
        }
    })) : (isFireStore ? item?.RankScoringList?.map((h) => ({
        id: h?.HorseId,
        horseNumber: h?.HorseNumber,
        horseName: isEn ? h?.HorseName : h?.HorseNameAr,
        rank: h?.HorseRank,
        totalPoint: h?.TotalScore,
        reason: h?.Reason,
        sire: isEn ? h?.Sire : h?.SireAr,
        dam: isEn ? h?.Dam : h?.DamAr,
        breeder: isEn ? h?.Breeder : h?.BreederAr,
        owner: isEn ? h?.Owner : h?.OwnerAr,
        color: isEn ? h?.Color : h?.ColorAr,
        birthDate: h?.BirthDate,
        classHorseScoringModel: {
            scoringTable: [],
            classHorseGallery: []
        }
    })) : item?.showClassHorseList) ?? [];

    const className = isFireStore ? currentLanguage == 'en' ? item?.ClassName : item?.ClassNameAr : isChampion ? item?.championshipName : item?.className
    const isExpanded = isFireStore ? true : expandedClass === ('panelClass' + index);
    const canExpand = showClassHorseList.length && showClassHorseList?.filter((horse) => horse?.horseName)?.length > 0;
    const galleryCheck = !!item?.videoUrl;
    const galleryData = !!item?.videoUrl ? [{ imageUrl: item?.videoUrl }] : [];
    return (
        <Accordion expanded={canExpand ? isExpanded : false} onChange={handleChangeClass('panelClass' + index)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
            >
                {className}

                <div className='text-end ms-auto'>
                    {galleryCheck &&
                        <div className='d-inline-block me-3 border-0 ' style={{ cursor: 'pointer' }} title={translate('web.viewHorseImages', 'View Horse Images')} onClick={(e) => (e.stopPropagation(), handleHorseimages(galleryData))}>
                            <i className="fa-solid fa-film"></i>
                        </div>
                    }
                    {showClassHorseList.length} <img src='./svgs/horse-head-solid.svg' style={{ height: 15 }} />
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {showClassHorseList.length > 0 && showClassHorseList.map((horse, index) => (
                    <HorseList isChampion={isChampion} showData={showData} item={item} isFromJson={item?.isFromJson ?? false} isFireStore={isFireStore} horse={horse} expanded={expanded} index={index} handleChange={handleChange} currentLanguage={currentLanguage} translate={translate} islive={islive} currentHorseData={currentHorseData} handleHorseimages={handleHorseimages} selectedHorseId={selectedHorseId} horsesRef={horsesRef} />
                ))}
                {(item?.isClassCompleted || item?.isChampionCompleted) &&
                    <div className='text-end'>
                        <Link className={'btn btn-outline-success mt-2'} title={translate('web.downloadResultAsPdf', 'Dowanload Result As PDF')} target="_blank" to={item?.downLoadUrl}>
                            <i className='fa-solid fa-file-pdf w-unset' />
                        </Link>
                    </div>
                }
                {!isFireStore && showClassHorseList?.at(-1)?.classHorseScoringModel?.scoringTable?.length > 0 &&
                    <div className='mx-1 mt-3'>
                        <span className='fw-bold'>
                            {translate('web.judges', 'judges')}:
                        </span>
                        <div className='row'>
                            <div className='col-12'>
                                <p>
                                    {showClassHorseList?.map((horse, index) => (
                                        index == 0 &&
                                        <>
                                            {horse?.classHorseScoringModel?.scoringTable?.map((judgeContainer, index) => (`${judgeContainer?.judgeLetter} - ${judgeContainer?.judgeName}`)).join(', ')}
                                            {/* {horse?.classHorseScoringModel?.scoringTable?.map((judgeContainer, index) => (`${judgeContainer?.judgeLetter} - ${judgeContainer?.judgeName}${(index + 1 !== horse?.classHorseScoringModel?.scoringTable?.length) && ', '}`))} */}
                                        </>
                                    ))}
                                </p>
                            </div>
                        </div>
                    </div>
                }
            </AccordionDetails>
        </Accordion>
    )
}
